import { ModalController } from 'ionic-angular';
import { Coin } from './../../models/Coin';
import { CoinsProvider } from './../../providers/coins/coins';
import { Component, Input, OnInit } from '@angular/core';
import { LiveSignal } from '../../models/Signal';
import { SignalsProvider } from '../../providers/signals/signals';
import { AddSignalStocksComponent } from '../add-signal-stocks/add-signal-stocks';
import { AddSignalComponent } from '../add-signal/add-signal';

/**
 * Generated class for the SignalViewComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'signal-view',
  templateUrl: 'signal-view.html'
})
export class SignalViewComponent implements OnInit {

  @Input('signal') signal: LiveSignal;
  @Input('withCard') withCard: boolean;

  coin: Coin;
  constructor(
    public CP: CoinsProvider,
    public modalCtrl: ModalController,
    public signalCtrl: SignalsProvider
  ) {
  }

  ngOnInit(){
    if(!this.signal.data.isStock){
      this.CP.getCoinByName(this.signal.data.coin).subscribe(coin =>{
        this.coin = coin;
      });
    }
  }

  openSignal(){
    let modal = null;
    let signal = this.signal;
    if(signal.data.isStock){
      modal = this.modalCtrl.create(AddSignalStocksComponent, {signal});
    }else{
      modal = this.modalCtrl.create(AddSignalComponent, {signal});
    }
    modal.present();
  
  }

}



// WEBPACK FOOTER //
// ./src/components/signal-view/signal-view.ts